import { SxProps, Theme } from '@mui/material';

export const stylesPaperHeader: SxProps<Theme> = {
  p: 3,
};

export const stylesButtonIconSquare: SxProps<Theme> = {
  p: '12px',
  minWidth: 'initial',
};

export const stylesButtonIconSquareSM: SxProps<Theme> = {
  px: '10px',
  minWidth: 'initial',
  fontSize: 'bodyLG.fontSize',
};
export const stylesTableColFull: SxProps<Theme> = {
  width: `100% !important`,
};
export const stylesTableColFixWidth: SxProps<Theme> = {
  width: `1px !important`,
};

export const stylesListItemHeader: SxProps<Theme> = {
  flex: 1,
  m: 0,
  pr: 4,
  label: {
    m: 0,
  },
  '.MuiListItemText-primary': {
    fontSize: 'bodySM.fontSize',
    fontWeight: 'fontWeightMedium',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '.MuiListItemText-secondary': {
    fontWeight: 'fontWeightMedium',
    fontSize: 'bodyXS.fontSize',
  },
};

export const stylesListItemSubContent: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  minWidth: 370,
  label: {
    m: 0,
  },
};

export const stylesListItemSubContentText: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  m: 0,
  '.MuiListItemText-primary': {
    fontWeight: 'fontWeightMedium',
    fontSize: 'bodySM.fontSize',
  },
  '.MuiListItemText-secondary': {
    fontWeight: 'fontWeightMedium',
    fontSize: 'bodyXS.fontSize',
  },
};

export const stylesListItemActionsBar: SxProps<Theme> = {
  textAlign: 'right',
  minWidth: 230,
  button: {
    ml: 3,
  },
  label: {
    ml: 3,
  },
};

export const stylesError: SxProps<Theme> = {
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  width: '100vw',
  backgroundColor: 'white',
  backgroundPosition: 'bottom right',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'auto 100%',
  p: '96px',
  zIndex: 9999,
  color: 'grey.800',
  '.MuiButton-text': {
    ml: -2,
    mb: 1,
    textTransform: 'uppercase',
  },
};

export const stylesErrorTitle: SxProps<Theme> = {
  fontSize: 96,
  mb: 4,
};

export const stylesErrorContent: SxProps<Theme> = {
  color: 'grey.600',
  mt: 4,
  mb: 3,
};

export const stylesLineVm = {
  px: 1,
  py: 0.5,
  display: 'inline-block',
  borderRadius: 1,
};

export const stylesTractorVrn = {
  border: '1px solid',
  borderColor: 'grey.200',
  backgroundColor: 'white',
};

export const stylesTrailerVrn = {
  backgroundColor: 'grey.200',
  borderColor: '',
};

export const stylesTextfieldSM = {
  '& .MuiInputBase-input': {
    py: 2,
  },
};

export const stylesCenteredLoader: SxProps<Theme> = {
  position: 'fixed',
  height: 'initial',
  width: 'initial',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%)',
};
